export default {"src":"/_next/static/media/play-hover.43ae6636.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};